import { MenuItem } from 'app/models/MenuItem';

export const ADMIN_MENU_ITEMS: MenuItem = {
	id: 'admin',
	label: 'Administrator',
	children: [
		{ id: 'clients-list', label: 'Client List', route: 'admin/clients/list', section: 'Administrator' },
		{ id: 'clients-add', label: 'Add Client', route: 'admin/clients/add', section: 'Administrator' },
		{ id: 'users-list', label: 'User List', route: 'admin/users/list', section: 'Administrator' },
		{ id: 'users-add', label: 'Add User', route: 'admin/users/add', section: 'Administrator' },
		{
			id: 'configuration-list',
			label: 'Configurations List',
			route: 'admin/configuration/list',
			section: 'Administrator',
		},
		{ id: 'roles', label: 'Roles', route: 'admin/roles', section: 'Administrator' },
		{
			id: 'payment-listing',
			label: 'Payments Listing Reports Update',
			route: 'admin/payment-listing',
			section: 'Administrator',
		},
		{
			id: 'workflow-forms-configuration',
			label: 'Workflow Editable Configuration',
			route: 'admin/workflow-forms-configuration',
			section: 'Administrator',
		},
		{
			id: 'administrative-roles-management',
			label: 'Administrative Roles Management',
			route: 'admin/administrative-roles-management',
			section: 'Administrator',
		},
		{ id: 'aichatlogs', label: 'AI Chat Logs', route: 'admin/aichatlogs', section: 'Administrator' },
		{ id: 'issues-report', label: 'Issues Report', route: 'pages/issues-report', section: 'Administrator' },
		{
			id: 'unclear-transactions-issues',
			label: 'Unclear Transaction Report',
			route: 'pages/unclear-transactions-issues',
			section: 'Administrator',
		},
	],
	section: 'Administrator',
};

export const DEFAULT_MENU_ITEMS: MenuItem[] = [
	{
		id: 'main-dashboard',
		label: 'Dashboard',
		route: 'dashboard',
		section: 'Dashboard',
	},
	{
		id: 'form-search',
		label: 'Form Search',
		route: 'pages/form-search',
		section: 'Form Search',
	},
	{
		id: 'quick-approval',
		label: 'Quick Approval',
		route: 'pages/quick-approval',
		section: 'Quick Approval',
	},
];

export const CHART_MENU_ITEMS: MenuItem[] = [
	{
		id: 'dashboard',
		label: 'Charts',
		children: [
			{
				id: 'dept-pct-vs-spend-by-account',
				label: 'Departmental Percentage Spend by Account Pie Chart',
				type: 'chart',
				section: 'Dashboard',
			},
			{
				id: 'dept-budget-vs-actual-by-account',
				label: 'Departmental Budget Vs Actual By Account',
				type: 'chart',
				section: 'Dashboard',
			},
			{
				id: 'dept-total-vs-used-by-purchased-order',
				label: 'Departmental Total Vs Used By Purchase Order',
				type: 'chart',
				section: 'Dashboard',
			},
			{
				id: 'budget-vs-actual-summary-by-dept',
				label: 'Budget Vs Actual Summary By Department',
				type: 'chart',
				section: 'Dashboard',
			},
		],
		section: 'Dashboard',
	},
];

export const AVAILABLE_FORM_ITEMS: MenuItem[] = [
	{
		id: 'announcements',
		label: 'Announcements',
		children: [
			{
				id: 'announcements-forms',
				label: 'Forms',
				children: [
					{
						id: 'announcement-form',
						label: 'Announcements',
						route: 'announcements/list',
						type: 'form',
						section: 'Announcements',
						formType: 'Announcement',
					},
				],
				type: 'form',
				section: 'Announcements',
			},
		],
		section: 'Announcements',
	},
	{
		id: 'miscellaneous-billing',
		label: 'Billing & AR',
		children: [
			{
				id: 'miscellaneous-billing-forms',
				label: 'Forms',
				children: [
					{
						id: 'customer-invoice-form',
						label: 'Invoice Form',
						route: 'miscellaneous-billing/customer-invoice',
						type: 'form',
						section: 'Billing & AR',
						formType: 'CustomerInvoiceForm',
					},
					{
						id: 'customer-form',
						label: 'Customer Form',
						route: 'miscellaneous-billing/customer-form',
						type: 'form',
						section: 'Billing & AR',
						formType: 'CustomerForm',
					},
					{
						id: 'quick-invoice-form',
						label: 'Quick Invoice Form',
						route: 'miscellaneous-billing/quick-invoice',
						type: 'form',
						section: 'Billing & AR',
						formType: 'QuickInvoiceForm',
					},
					{
						id: 'invoice-adjustment-form',
						label: 'Invoice Adjustment Form',
						route: 'miscellaneous-billing/customer-invoice-adjustment-form',
						type: 'form',
						section: 'Billing & AR',
						formType: 'InvoiceAdjustmentForm',
					},
					{
						id: 'customer-credit-memos',
						label: 'Customer Credit Memo',
						route: 'miscellaneous-billing/customer-credit-memos',
						type: 'form',
						section: 'Billing & AR',
						formType: 'CustomerCreditMemosForm',
					},
				],
				type: 'form',
				section: 'Billing & AR',
			},
			{
				id: 'miscellaneous-billing-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'customer-invoice-list',
						label: 'Invoice Management',
						route: 'miscellaneous-billing/customer-invoice-list',
						type: 'data-management',
						section: 'Billing & AR',
					},
					{
						id: 'credit-card-fee-configuration',
						label: 'Credit Card Fee Configuration',
						route: 'miscellaneous-billing/credit-card-fee-configuration',
						type: 'data-management',
						section: 'Billing & AR',
					},
					{
						id: 'customer-list',
						label: 'Customer Management',
						route: 'miscellaneous-billing/customer-list',
						type: 'data-management',
						section: 'Billing & AR',
					},
					{
						id: 'quick-invoice-list',
						label: 'Quick Invoice Management',
						route: 'miscellaneous-billing/quick-invoice-list',
						type: 'data-management',
						section: 'Billing & AR',
					},
					{
						id: 'customer-credit-memos-list',
						label: 'Customer Credit Memo Management',
						route: 'miscellaneous-billing/customer-credit-memos-list',
						type: 'data-management',
						section: 'Billing & AR',
					},
					{
						id: 'late-fee-configuration',
						label: 'Late Fee Configuration',
						route: 'miscellaneous-billing/late-fee-configuration',
						type: 'data-management',
						section: 'Billing & AR',
					},
				],
				type: 'data-management',
				section: 'Billing & AR',
			},
			{
				id: 'miscellaneous-billing-reports',
				label: 'Reports',
				children: [
					{
						id: 'invoice-report',
						label: 'Outstanding A/R Report',
						route: 'miscellaneous-billing/invoice-report',
						type: 'report',
						section: 'Billing & AR',
					},
					{
						id: 'receipt-transaction-detail-report',
						label: 'Receipt Transaction Detail Report',
						route: 'miscellaneous-billing/receipt-transaction-detail-report',
						type: 'report',
						section: 'Billing & AR',
					},
				],
				type: 'report',
				section: 'Billing & AR',
			},
		],
		section: 'Billing & AR',
	},
	{
		id: 'budgeting',
		label: 'Budgeting',
		children: [
			{
				id: 'budgeting-forms',
				label: 'Forms',
				children: [
					{
						id: 'dpt-exp-budget',
						label: 'Next Year Expenses Budget',
						route: 'forms/budget/operating',
						type: 'form',
						section: 'Budgeting',
						formType: 'DepartmentExpenseBudget',
					},
					{
						id: 'fund-rev-budget',
						label: 'Next Year Revenue Budget',
						route: 'forms/budget/revenue',
						type: 'form',
						section: 'Budgeting',
						formType: 'FundRevenueBudget',
					},
					{
						id: 'capital-budget',
						label: 'Next Year Capital Budget',
						route: 'forms/budget/capital',
						type: 'form',
						section: 'Budgeting',
						formType: 'CapitalBudget',
					},
					{
						id: 'operating-expense-budget',
						label: 'Next Year Operating Expense Budget',
						route: 'forms/budget/operating-expense',
						type: 'form',
						section: 'Budgeting',
						formType: 'OperatingExpenseBudget',
					},
					{
						id: 'budget-amend',
						label: 'Budget Amendment',
						route: 'forms/budget/amendment/create',
						type: 'form',
						section: 'Budgeting',
						formType: 'BudgetAmendment',
					},
					{
						id: 'budget-transfer',
						label: 'Budget Transfer',
						route: 'forms/budget/transfer/create',
						type: 'form',
						section: 'Budgeting',
						formType: 'BudgetTransfer',
					},
					{
						id: 'personnel-budget-form',
						label: 'Next Year Personnel Budget',
						route: 'forms/budget/personnel',
						type: 'form',
						section: 'Budgeting',
						formType: 'PersonnelBudgetForm',
					},
					{
						id: 'new-hire-request-form',
						label: 'New Hire Request Form',
						route: 'forms/budget/new-hire-request-form',
						type: 'form',
						section: 'Budgeting',
						formType: 'NewHireRequestForm',
					},
				],
				type: 'form',
				section: 'Budgeting',
			},
			{
				id: 'budgeting-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'budget-configurations',
						label: 'Budget Version Analysis',
						route: 'forms/budget/configurations',
						type: 'data-management',
						section: 'Budgeting',
						formType: 'BudgetConfiguration',
					},
					{
						id: 'budget-balance-management',
						label: 'Budget Balance Management',
						route: 'forms/budget/balance/management',
						type: 'data-management',
						section: 'Budgeting',
					},
					{
						id: 'budget-forecasting',
						label: 'Monthly Budget Forecasting',
						route: 'forms/budget/forecasting',
						type: 'data-management',
						section: 'Budgeting',
					},
					{
						id: 'multi-year-budgeting',
						label: 'Multi Year Budgeting',
						route: 'forms/budget/balance/multi-year',
						type: 'data-management',
						section: 'Budgeting',
					},
					{
						id: 'budgeting-position-control-management',
						label: 'Budget Position Control Management',
						route: 'forms/budget/position-control-management',
						type: 'data-management',
						section: 'Budgeting',
					},
					{
						id: 'budgeting-benefit-types-listing',
						label: 'Budget Benefit Type',
						route: 'forms/budget/benefit-types-listing',
						type: 'data-management',
						section: 'Budgeting',
					},
					{
						id: 'budgeting-benefits-listing',
						label: 'Budget Benefits Management',
						route: 'forms/budget/benefits-management',
						type: 'data-management',
						section: 'Budgeting',
					},
					{
						id: 'budgeting-personnel-rounding-configuration',
						label: 'Personnel Rounding Configuration',
						route: 'forms/budget/personnel-rounding-configuration',
						type: 'data-management',
						section: 'Budgeting',
					},
					{
						id: 'annual-position-control-management',
						label: 'Annual Position Control Management',
						route: 'forms/budget/annual-position-control-management',
						type: 'data-management',
						section: 'Budgeting',
					},
				],
				type: 'data-management',
				section: 'Budgeting',
			},
			{
				id: 'budgeting-reports',
				label: 'Reports',
				children: [
					{
						id: 'personnel-details-report',
						label: 'Personnel Details Report',
						route: 'forms/budget/personnel-details-report',
						type: 'report',
						section: 'Budgeting',
					},
					{
						id: 'budget-overview',
						label: 'Budget Overview',
						route: 'forms/budget/overview',
						type: 'report',
						section: 'Budgeting',
					},
					{
						id: 'capital-overview',
						label: 'Capital Budget Overview',
						route: 'forms/budget/capital-overview',
						type: 'report',
						section: 'Budgeting',
					},
					{
						id: 'budget-details',
						label: 'Inflow & Outflow Budget Details',
						route: 'forms/budget/budget-details',
						type: 'report',
						section: 'Budgeting',
					},
					{
						id: 'capital-budget-details',
						label: 'Capital Budget Details',
						route: 'forms/budget/capital-budget-details',
						type: 'report',
						section: 'Budgeting',
					},
					{
						id: 'operating-expense-details',
						label: 'Operating Expense Details',
						route: 'forms/budget/operating-expense-details',
						type: 'report',
						section: 'Budgeting',
					},
					{
						id: 'benefits-budget-version-report',
						label: 'Benefits Budget Version Report',
						route: 'forms/budget/benefits-budget-version-report',
						type: 'report',
						section: 'Budgeting',
					},
					{
						id: 'gl-account-budget-analysis-report',
						label: 'GL Account Budget Analysis Report',
						route: 'forms/budget/gl-account-budget-analysis-report',
						type: 'report',
						section: 'Budgeting',
					},
				],
				type: 'report',
				section: 'Budgeting',
			},
		],
		section: 'Budgeting',
	},
	{
		id: 'capital-item',
		label: 'Capital Assets',
		children: [
			{
				id: 'capital-item-forms',
				label: 'Forms',
				children: [
					{
						id: 'addition-form',
						label: 'Capital Asset Addition Form',
						route: 'capital-assets/addition-form',
						type: 'form',
						section: 'Capital Assets',
						formType: 'AssetAdditionForm',
					},
					{
						id: 'disposal-form',
						label: 'Capital Asset Disposal Form',
						route: 'capital-assets/disposal-form',
						type: 'form',
						section: 'Capital Assets',
						formType: 'DisposalForm',
					},
					{
						id: 'transfer-form',
						label: 'Capital Asset Transfer Form',
						route: 'capital-assets/transfer-form',
						type: 'form',
						section: 'Capital Assets',
						formType: 'AssetTransferForm',
					},
					{
						id: 'depreciation-schedule-form',
						label: 'Depreciation Schedule Form',
						route: 'capital-assets/depreciation-schedule-form',
						type: 'form',
						section: 'Capital Assets',
						formType: 'DepreciationScheduleForm',
					},
					{
						id: 'reclassification-form',
						label: 'Capital Outlay Reclass Form',
						route: 'capital-assets/reclassification',
						type: 'form',
						section: 'Capital Assets',
						formType: 'ReclassificationForm',
					},
					{
						id: 'asset-work-order-form',
						label: 'Capital Asset Work Order Form',
						route: 'capital-assets/asset-work-order-form',
						type: 'form',
						section: 'Capital Assets',
						formType: 'AssetWorkOrderForm',
					},
				],
				type: 'form',
				section: 'Capital Assets',
			},
			{
				id: 'capital-item-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'asset-management',
						label: 'Capital Asset Management',
						route: 'capital-assets/management/asset',
						type: 'data-management',
						section: 'Capital Assets',
					},
					{
						id: 'depreciation-management',
						label: 'Depreciation Management',
						route: 'capital-assets/depreciation-management',
						type: 'data-management',
						section: 'Capital Assets',
					},
					{
						id: 'asset-inventory-management',
						label: 'Asset Inventory Management',
						route: 'capital-assets/asset-inventory-management',
						type: 'data-management',
						section: 'Capital Assets',
					},
					{
						id: 'asset-types',
						label: 'Asset Types Management',
						route: 'capital-assets/management/types',
						type: 'data-management',
						section: 'Capital Assets',
					},
					{
						id: 'asset-gl-accounts-mapping',
						label: 'Asset GL Accounts Mapping',
						route: 'capital-assets/management/mapping',
						type: 'data-management',
						section: 'Capital Assets',
					},
					{
						id: 'asset-addition-form-configuration-list',
						label: 'Asset Addition Form Configuration',
						route: 'capital-assets/asset-addition-form-configuration-list',
						type: 'data-management',
						section: 'Capital Assets',
					},
				],
				type: 'data-management',
				section: 'Capital Assets',
			},
			{
				id: 'capital-item-reports',
				label: 'Reports',
				children: [
					{
						id: 'capital-outlay-report',
						label: 'Capital Outlay Report',
						route: 'capital-assets/capital-outlay-report',
						type: 'report',
						section: 'Capital Assets',
					},
					{
						id: 'capital-asset-reports',
						label: 'Capital Asset Reports',
						route: 'capital-assets/asset-list',
						type: 'report',
						section: 'Capital Assets',
					},
				],
				type: 'report',
				section: 'Capital Assets',
			},
		],
		section: 'Capital Assets',
	},
	{
		id: 'cashiering-report',
		label: 'Cashiering',
		children: [
			{
				id: 'cashiering-report-forms',
				label: 'Forms',
				children: [
					{
						id: 'cashiering-report',
						label: 'Cashiering Close Out Form',
						route: 'forms/cashiering-report',
						type: 'form',
						section: 'Cashiering',
						formType: 'CashieringReport',
					},
					{
						id: 'cash-receipt-form',
						label: 'Cash Receipt Form',
						route: 'forms/cash-receipt-form',
						type: 'form',
						section: 'Cashiering',
						formType: 'CashReceiptForm',
					},
					{
						id: 'cash-bond-form',
						label: 'Cash Bond Receipt Form',
						route: 'forms/cash-bond-receipt-form',
						type: 'form',
						section: 'Cashiering',
						formType: 'CashBondReceiptForm',
					},
					{
						id: 'daily-fees-import-form',
						label: 'Daily Fees Import Form',
						route: 'forms/daily-fees-import-form',
						type: 'form',
						section: 'Cashiering',
						formType: 'DailyFeesImportForm',
					},
					{
						id: 'bulk-cash-receipt-form',
						label: 'Bulk Cash Receipt Form',
						route: 'forms/bulk-cash-receipt-form',
						type: 'form',
						section: 'Cashiering',
						formType: 'BulkCashReceiptForm',
					},
					{
						id: 'cashiering-adjustment-form',
						label: 'Cashiering Adjustment Form',
						route: 'forms/cashiering-adjustment-form',
						type: 'form',
						section: 'Cashiering',
						formType: 'CashieringAdjustmentForm',
					},
				],
				type: 'form',
				section: 'Cashiering',
			},
			{
				id: 'cashiering-report-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'cashiering-config',
						label: 'Cashiering Configuration',
						route: 'forms/cashiering-config',
						type: 'data-management',
						section: 'Cashiering',
					},
					{
						id: 'credit-card-processing',
						label: 'Credit Card Processing',
						route: 'forms/credit-card-processing',
						type: 'data-management',
						section: 'Cashiering',
					},
					{
						id: 'electronic-ach-processing',
						label: 'Electronic/ACH Processing',
						route: 'forms/electronic-ach-processing',
						type: 'data-management',
						section: 'Cashiering',
					},
					{
						id: 'payment-processors-list',
						label: 'Payment Processors Management',
						route: 'forms/payment-processors-list',
						type: 'data-management',
						section: 'Cashiering',
					},
					{
						id: 'daily-fees-import-configuration',
						label: 'Daily Fees Import Configuration',
						route: 'forms/daily-fees-import-configuration',
						type: 'data-management',
						section: 'Cashiering',
					},
					{
						id: 'cashiering-closeout-processing',
						label: 'Cashiering Closeout Processing',
						route: 'forms/cashiering-closeout-processing',
						type: 'data-management',
						section: 'Cashiering',
					},
				],
				type: 'data-management',
				section: 'Cashiering',
			},
			{
				id: 'cashiering-report-reports',
				label: 'Reports',
				children: [
					{
						id: 'credit-card-report',
						label: 'Credit Card Report',
						route: 'forms/credit-card-report',
						type: 'report',
						section: 'Cashiering',
					},
					{
						id: 'cashiering-report-listing',
						label: 'Cashiering Report Listing',
						route: 'forms/cashiering-report-listing',
						type: 'report',
						section: 'Cashiering',
					},
					{
						id: 'electronic-ach-report',
						label: 'Electronic/ACH Report',
						route: 'forms/electronic-ach-report',
						type: 'report',
						section: 'Cashiering',
					},
					{
						id: 'custom-cashiering-report',
						label: 'Cashiering Report',
						route: 'forms/custom-cashiering-report',
						type: 'report',
						section: 'Cashiering',
					},
					{
						id: 'daily-fees-import-report',
						label: 'Daily Fees Import Report',
						route: 'forms/daily-fees-import-report',
						type: 'report',
						section: 'Cashiering',
					},
					{
						id: 'cashiering-closeout-report',
						label: 'Cashiering Closeout Report',
						route: 'forms/cashiering-closeout-report',
						type: 'report',
						section: 'Cashiering',
					},
				],
				type: 'report',
				section: 'Cashiering',
			},
		],
		section: 'Cashiering',
	},
	{
		id: 'client-support',
		label: 'Client Support',
		children: [
			{
				id: 'client-support-forms',
				label: 'Forms',
				children: [
					{
						id: 'enhancement-request-form',
						label: 'Enhancement Request Form',
						route: '/forms/enhancement-request-form',
						type: 'form',
						section: 'Client Support',
						formType: 'EnhancementRequestForm',
					},
					{
						id: 'client-survey-form',
						label: 'Client Survey Form',
						route: '/forms/client-survey-form',
						type: 'form',
						section: 'Client Support',
						formType: 'ClientSurveyForm',
					},
				],
				type: 'form',
				section: 'Client Support',
			},
			{
				id: 'client-support-reports',
				label: 'Reports',
				children: [
					{
						id: 'faq-report',
						label: 'FAQ Report',
						route: '/forms/faq-report',
						type: 'report',
						section: 'Client Support',
					},
				],
				type: 'report',
				section: 'Client Support',
			},
		],
		section: 'Client Support',
	},
	{
		id: 'code-enforcement',
		label: 'Code Enforcement',
		children: [
			{
				id: 'code-enforcement-forms',
				label: 'Forms',
				children: [
					{
						id: 'complainant-form',
						label: 'Complainant Form',
						route: 'code-enforcement/complainant-form',
						type: 'form',
						section: 'Code Enforcement',
						formType: 'Case',
					},
				],
				type: 'form',
				section: 'Code Enforcement',
			},
			{
				id: 'code-enforcement-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'complainant-listing',
						label: 'Complainant Listing',
						route: 'code-enforcement/complainant-listing',
						type: 'data-management',
						section: 'Code Enforcement',
					},
					{
						id: 'violation-type-management',
						label: 'Violation Type Management',
						route: 'code-enforcement/violation-types',
						type: 'data-management',
						section: 'Code Enforcement',
					},
					{
						id: 'code-enforcement-configuration',
						label: 'Code Enforcement Configuration',
						route: 'code-enforcement/code-enforcement-configuration',
						type: 'data-management',
						section: 'Code Enforcement',
					},
				],
				type: 'data-management',
				section: 'Code Enforcement',
			},
			{
				id: 'code-enforcement-reports',
				label: 'Reports',
				children: [
					{
						id: 'code-enforcement-dashboard',
						label: 'Dashboard',
						route: 'code-enforcement/code-enforcement-dashboard',
						type: 'report',
						section: 'Code Enforcement',
					},
				],
				type: 'report',
				section: 'Code Enforcement',
			},
		],
		section: 'Code Enforcement',
	},
	{
		id: 'dynamic-forms',
		label: 'Dynamic Forms',
		children: [
			{
				id: 'dynamic-forms-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'additional-field-configurations',
						label: 'Additional Field Configurations',
						route: 'dynamic-forms/additional-field-list',
						type: 'data-management',
						section: 'Dynamic Forms',
					},
				],
				type: 'data-management',
				section: 'Dynamic Forms',
			},
		],
		section: 'Dynamic Forms',
	},
	{
		id: 'general-ledger',
		label: 'General Ledger',
		children: [
			{
				id: 'general-ledger-forms',
				label: 'Forms',
				children: [
					{
						id: 'journal-entry',
						label: 'Journal Entry Form',
						route: 'generalledger/journal-form',
						type: 'form',
						section: 'General Ledger',
						formType: 'JournalEntryForm',
					},
					{
						id: 'department-addition-form',
						label: 'Organization Addition Form',
						route: 'generalledger/department-addition',
						type: 'form',
						section: 'General Ledger',
						formType: 'DepartmentAdditionForm',
					},
					{
						id: 'fund-addition-form',
						label: 'Entity Addition Form',
						route: 'generalledger/fund-addition-form',
						type: 'form',
						section: 'General Ledger',
						formType: 'FundAdditionForm',
					},
					{
						id: 'gl-account',
						label: 'Account Creation Form',
						route: 'generalledger/gl-account',
						type: 'form',
						section: 'General Ledger',
						formType: 'AccountCreationForm',
					},
					{
						id: 'open-close-period',
						label: 'Open Close Period',
						route: 'generalledger/open-close-period',
						type: 'form',
						section: 'General Ledger',
						formType: 'OpenClosePeriodForm',
					},
				],
				type: 'form',
				section: 'General Ledger',
			},
			{
				id: 'general-ledger-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'department-list',
						label: 'Organization List',
						route: 'generalledger/organization-list',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'fund-list',
						label: 'Entity List',
						route: 'generalledger/entity-list',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'chart-of-accounts',
						label: 'Chart Of Accounts',
						route: 'generalledger/chart-of-accounts',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'account-management',
						label: 'Account Management',
						route: 'generalledger/account/list',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'open-close-period-management',
						label: 'Open Close Period Management',
						route: 'generalledger/open-close-period-list',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'account-type-list',
						label: 'Account Types',
						route: 'generalledger/account-types/list',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'account-characters-list',
						label: 'Account Characters',
						route: 'generalledger/account-characters/list',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'account-numbers-list',
						label: 'Account Numbers',
						route: 'generalledger/account-numbers/list',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'object-codes-list',
						label: 'Object Codes',
						route: 'generalledger/object-codes/list',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'account-ranges-list',
						label: 'Account Ranges',
						route: 'generalledger/account-ranges/list',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'account-mapping-list',
						label: 'Account Mappings',
						route: 'generalledger/account-mapping/list',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'period-thirteen-configuration',
						label: 'Period 13 Configuration',
						route: 'generalledger/period-thirteen-configuration',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'gl-import-management',
						label: 'GL Import Management',
						route: 'generalledger/gl-import-management',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'parent-fund-list',
						label: 'Parent Funds',
						route: 'generalledger/parent-funds/list',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'parent-departments-list',
						label: 'Parent Departments',
						route: 'generalledger/parent-departments/list',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'financial-statement-line-item-list',
						label: 'Financial Statement Line Item List',
						route: 'generalledger/financial-statement/list',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'account-characters-filter-list',
						label: 'Account Character Filter Management',
						route: 'generalledger/account-characters-filter-list',
						type: 'data-management',
						section: 'General Ledger',
					},
					{
						id: 'fund-types-filter-list',
						label: 'Fund Type Filter Management',
						route: 'generalledger/fund-types-filter-list',
						type: 'data-management',
						section: 'General Ledger',
					},
				],
				type: 'data-management',
				section: 'General Ledger',
			},
			{
				id: 'general-ledger-reports',
				label: 'Reports',
				children: [
					{
						id: 'revenues-expenses-report',
						label: 'Revenues & Expenses Report',
						route: 'generalledger/revenues-expenses-report',
						type: 'report',
						section: 'General Ledger',
					},
					{
						id: 'expenses-report',
						label: 'Expenditures Report',
						route: 'generalledger/expenses-report',
						type: 'report',
						section: 'General Ledger',
					},
					{
						id: 'trial-balance',
						label: 'Trial Balance Report',
						route: 'generalledger/trial-balance',
						type: 'report',
						section: 'General Ledger',
					},
					{
						id: 'gl-transaction',
						label: 'Transaction Report',
						route: 'generalledger/gl-transaction',
						type: 'report',
						section: 'General Ledger',
					},
					{
						id: 'balance-sheet-report',
						label: 'Balance Sheet Report',
						route: 'generalledger/balance-sheet-report',
						type: 'report',
						section: 'General Ledger',
					},
					{
						id: 'budget-actual-report',
						label: 'Budget vs Actual Report',
						route: 'generalledger/budget-actual-report',
						type: 'report',
						section: 'General Ledger',
					},
					{
						id: 'budget-actual-multi-year-report',
						label: 'Multi-Year Budget Vs Actual',
						route: 'generalledger/budget-actual-multi-year-report',
						type: 'report',
						section: 'General Ledger',
					},
					{
						id: 'budget-actual-exp-report',
						label: 'Budget vs Actual Expense Report',
						route: 'generalledger/budget-actual-exp-report',
						type: 'report',
						section: 'General Ledger',
					},
				],
				type: 'report',
				section: 'General Ledger',
			},
		],
		section: 'General Ledger',
	},
	{
		id: 'hris',
		label: 'HR',
		children: [
			{
				id: 'hris-forms',
				label: 'Forms',
				children: [
					{
						id: 'job-application',
						label: 'Job Posting',
						route: 'forms/hris/job-application',
						type: 'form',
						section: 'HR',
						formType: 'JobApplication',
					},
					{
						id: 'new-hire-form',
						label: 'New Hire Form',
						route: 'forms/hris/employee/create-employee',
						type: 'form',
						section: 'HR',
						formType: 'EmployeeHireForm',
					},
					{
						id: 'benefit-enrolment-form',
						label: 'Benefit Enrollment Form',
						route: 'forms/hris/benefits-enrollment-form',
						type: 'form',
						section: 'HR',
						formType: 'BenefitEnrolmentForm',
					},
					{
						id: 'employee-action-form',
						label: 'Employee Action Form',
						route: 'forms/hris/employee/action',
						type: 'form',
						section: 'HR',
						formType: 'EmployeeActionForm',
					},
					{
						id: 'performance-evaluation',
						label: 'Performance Evaluation Form',
						route: 'forms/hris/performance-evaluation',
						type: 'form',
						section: 'HR',
						formType: 'PerformanceEvaluation',
					},
					{
						id: 'time-off-request-form',
						label: 'Time Off Request Form',
						route: 'forms/hris/timeoff',
						type: 'form',
						section: 'HR',
						formType: 'TimeOffForm',
					},
					{
						id: 'leave-balance-adjustment',
						label: 'Leave Balance Adjustment Form',
						route: 'forms/hris/leave-balance-adjustment',
						type: 'form',
						section: 'HR',
						formType: 'LeaveBalanceAdjustmentForm',
					},
					{
						id: 'benefit-enrollment',
						label: 'New Benefit Form',
						route: 'forms/hris/add-benefit',
						type: 'form',
						section: 'HR',
					},
					{
						id: 'mass-pay-rate-change-form',
						label: 'Mass Pay Rate Change Form',
						route: 'forms/hris/mass-pay-rate-change-form',
						type: 'form',
						section: 'HR',
						formType: 'MassPayRateChangeForm',
					},
					{
						id: 'leave-balance-payout-form',
						label: 'Leave Balance Payout Form',
						route: 'forms/hris/leave-balance-payout-form',
						type: 'form',
						section: 'HR',
						formType: 'LeaveBalancePayoutForm',
					},
				],
				type: 'form',
				section: 'HR',
			},
			{
				id: 'hris-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'job-applications',
						label: 'Job Postings',
						route: 'forms/hris/job-application/list',
						type: 'data-management',
						section: 'HR',
					},
					{
						id: 'job-applicants',
						label: 'Applicants',
						route: 'forms/hris/job-applicant/list',
						type: 'data-management',
						section: 'HR',
					},
					{
						id: 'time-off-list',
						label: 'Time Off Requests',
						route: 'forms/hris/timeoff/list',
						type: 'data-management',
						section: 'HR',
					},
					// {
					// 	id: 'employee-management',
					// 	label: 'Employee Details',
					// 	route: 'forms/hris/employee/details',
					// 	type: 'data-management',
					// 	section: 'HR',
					// },
					{
						id: 'benefits-management',
						label: 'Benefits Management',
						route: 'forms/hris/benefits',
						type: 'data-management',
						section: 'HR',
					},
					{
						id: 'benefit-type',
						label: 'Benefit Types',
						route: 'forms/hris/benefit-type-listing',
						type: 'data-management',
						section: 'HR',
					},
					{
						id: 'employee-listing',
						label: 'Employee Listing',
						route: 'forms/hris/employee/list',
						type: 'data-management',
						section: 'HR',
					},
					{
						id: 'Leave-Balance-Configuration',
						label: 'Leave Balance Configuration',
						route: 'forms/hris/leave-balance-configuration',
						type: 'data-management',
						section: 'HR',
					},
					{
						id: 'leave-balance-management',
						label: 'Leave Balance Management',
						route: 'forms/hris/leave-balance-management',
						type: 'data-management',
						section: 'HR',
					},
					{
						id: 'Benefits-Configuration',
						label: 'Benefits Configuration',
						route: 'forms/hris/benefits-configuration',
						type: 'data-management',
						section: 'HR',
					},
					{
						id: 'position-control-management',
						label: 'Position Control Management',
						route: 'forms/hris/position-control-management',
						type: 'data-management',
						section: 'HR',
					},
					{
						id: 'benefit-w2-applicable-type',
						label: 'W2 Applicable Types',
						route: 'forms/hris/benefit-w2-applicable-type-listing',
						type: 'data-management',
						section: 'HR',
					},
					{
						id: 'hris-configuration-listing',
						label: 'HR Configuration Management',
						route: 'forms/hris/hris-configuration-listing',
						type: 'data-management',
						section: 'HR',
					},
					{
						id: 'performance-evaluation-method-configuration',
						label: 'Performance Evaluation Configuration',
						route: 'forms/hris/performance-evaluation-method-configuration',
						type: 'data-management',
						section: 'HR',
					},
				],
				type: 'data-management',
				section: 'HR',
			},
			{
				id: 'hris-reports',
				label: 'Reports',
				children: [
					{
						id: 'benefit-enrollment-report',
						label: 'Benefit Enrollment Report',
						route: 'forms/hris/employee/benefit-enrollment-report',
						type: 'report',
						section: 'HR',
					},
					{
						id: 'hr-report',
						label: 'HR Report',
						route: 'forms/hris/employee/hr-report',
						type: 'report',
						section: 'HR',
					},
					{
						id: 'leave-balance-report',
						label: 'Leave Balance Report',
						route: 'forms/hris/leave-balance-report',
						type: 'report',
						section: 'HR',
					},
					{
						id: 'benefits-deduction-report',
						label: 'Benefits Deduction Report',
						route: 'forms/hris/benefits-deduction-report',
						type: 'report',
						section: 'HR',
					},
					{
						id: 'general-ledger-configuration-report',
						label: 'General Ledger Configuration Report',
						route: 'forms/hris/employee/general-ledger-configuration-report',
						type: 'report',
						section: 'HR',
					},
					{
						id: 'employee-detail-report',
						label: 'Employee Detail Report',
						route: 'forms/hris/employee-detail-report',
						type: 'report',
						section: 'HR',
					},
					{
						id: 'direct-deposit-report',
						label: 'Employee Direct Deposit Report',
						route: 'forms/hris/employee/direct-deposit-report',
						type: 'report',
						section: 'HR',
					},
					{
						id: 'time-off-requests-report',
						label: 'Time Off Requests Report',
						route: 'forms/hris/time-off-requests-report',
						type: 'report',
						section: 'HR',
					},
				],
				type: 'report',
				section: 'HR',
			},
		],
		section: 'HR',
	},
	{
		id: 'hr',
		label: 'HR and Payroll',
		children: [
			{
				id: 'hr-forms',
				label: 'Forms',
				children: [
					{
						id: 'timesheet',
						label: 'Time Sheet Form',
						route: 'forms/timesheet',
						type: 'form',
						section: 'HR and Payroll',
						formType: 'TimeSheet',
					},
					{
						id: 'hr-support',
						label: 'Human Resources Support',
						route: 'forms/hr-support',
						type: 'form',
						section: 'HR and Payroll',
						formType: 'HRSupportRequest',
					},
				],
				type: 'form',
				section: 'HR and Payroll',
			},
		],
		section: 'HR and Payroll',
	},
	{
		id: 'implementation',
		label: 'Implementation',
		children: [
			{
				id: 'implementation-forms',
				label: 'Forms',
				children: [
					{
						id: 'implementation-billing-ar',
						label: 'Billing & AR Implementation',
						route: 'forms/implementation-billing-ar',
						type: 'form',
						section: 'Implementation',
						formType: 'Implementation',
					},
					{
						id: 'implementation-general-ledger',
						label: 'General Ledger Implementation',
						route: 'forms/implementation-general-ledger',
						type: 'form',
						section: 'Implementation',
						formType: 'ImplementationGL',
					},
					{
						id: 'implementation-purchasing',
						label: 'Purchasing Implementation',
						route: 'forms/implementation-purchasing',
						type: 'form',
						section: 'Implementation',
						formType: 'ImplementationPur',
					},
					{
						id: 'implementation-payment',
						label: 'Payments Implementation',
						route: 'forms/implementation-payment',
						type: 'form',
						section: 'Implementation',
						formType: 'ImplementationPay',
					},
					{
						id: 'implementation-hr',
						label: 'Human Resource Implementation',
						route: 'forms/implementation-hr',
						type: 'form',
						section: 'Implementation',
						formType: 'ImplementationHR',
					},
					{
						id: 'go-live-approval-form',
						label: 'Go Live Approval Form',
						route: 'forms/go-live-approval-form',
						type: 'form',
						section: 'Implementation',
						formType: 'GoLiveApprovalForm',
					},
					{
						id: 'training-certification-form',
						label: 'Training Certification Form',
						route: 'forms/training-certification-form',
						type: 'form',
						section: 'Implementation',
						formType: 'TrainingCertificationForm',
					},
					{
						id: 'implementation-payroll',
						label: 'Payroll Implementation',
						route: 'forms/implementation-payroll',
						type: 'form',
						section: 'Implementation',
						formType: 'ImplementationPayroll',
					},
					{
						id: 'customer-feedback-survey',
						label: 'Customer Feedback Survey',
						route: 'forms/customer-feedback-survey',
						type: 'form',
						section: 'Implementation',
						formType: 'CustomerFeedbackSurvey',
					},
				],
				type: 'form',
				section: 'Implementation',
			},
			{
				id: 'implementation-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'module-task-tracking-management',
						label: 'Module Task Tracking',
						route: 'forms/module-task-tracking-management',
						type: 'data-management',
						section: 'Implementation',
						formType: 'ImplementationHR',
					},
				],
				type: 'data-management',
				section: 'Implementation',
			},
		],
		section: 'Implementation',
	},
	{
		id: 'integrations',
		label: 'Integrations',
		children: [
			{
				id: 'integrations-reports',
				label: 'Reports',
				children: [
					{
						id: 'paysafe-transactions-report',
						label: 'PaySafe Transactions Report',
						route: 'integrations/paysafe-transactions-report',
						type: 'report',
						section: 'Integrations',
					},
				],
				type: 'report',
				section: 'Integrations',
			},
		],
		section: 'Integrations',
	},
	{
		id: 'inventory',
		label: 'Inventory',
		children: [
			{
				id: 'inventory-forms',
				label: 'Forms',
				children: [
					{
						id: 'receiving-form',
						label: 'Receiving Form',
						route: 'inventory/receiving-form',
						type: 'form',
						section: 'Inventory',
						formType: 'ReceivingForm',
					},
					{
						id: 'usage-form',
						label: 'Usage Form',
						route: 'inventory/usage-form',
						type: 'form',
						section: 'Inventory',
						formType: 'UsageForm',
					},
					{
						id: 'adjustment-form',
						label: 'Adjustment Form',
						route: 'inventory/adjustment-form',
						type: 'form',
						section: 'Inventory',
						formType: 'AdjustmentForm',
					},
					{
						id: 'item-form',
						label: 'Item Form',
						route: 'inventory/item-form',
						type: 'form',
						section: 'Inventory',
						formType: 'ItemForm',
					},
					{
						id: 'location-form',
						label: 'Location Form',
						route: 'inventory/location-form',
						type: 'form',
						section: 'Inventory',
						formType: 'LocationForm',
					},
				],
				type: 'form',
				section: 'Inventory',
			},
			{
				id: 'inventory-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'item-management',
						label: 'Item Management',
						route: 'inventory/item-management',
						type: 'data-management',
						section: 'Inventory',
					},
					{
						id: 'location-management',
						label: 'Location Management',
						route: 'inventory/location-management',
						type: 'data-management',
						section: 'Inventory',
					},
					{
						id: 'inventory-gl-configuration',
						label: 'Inventory GL Configuration',
						route: 'inventory/inventory-gl-configuration',
						type: 'data-management',
						section: 'Inventory',
					},
				],
				type: 'data-management',
				section: 'Inventory',
			},
			{
				id: 'inventory-reports',
				label: 'Reports',
				children: [
					{
						id: 'inventory-balances-report',
						label: 'Inventory Balances Report',
						route: 'inventory/inventory-balances-report',
						type: 'report',
						section: 'Inventory',
					},
				],
				type: 'report',
				section: 'Inventory',
			},
		],
		section: 'Inventory',
	},
	{
		id: 'capital-lease-accounting',
		label: 'Lease Accounting',
		children: [
			{
				id: 'capital-lease-accounting-forms',
				label: 'Forms',
				children: [
					{
						id: 'lease-evaluation',
						label: 'Lease Evaluation',
						route: 'capital-lease/lease-evaluation',
						type: 'form',
						section: 'Lease Accounting',
						formType: 'LeaseEvaluation',
					},
					{
						id: 'new-capital-lease-form',
						label: 'New Capital Lease Form',
						route: 'capital-lease/new-capital-lease-form',
						type: 'form',
						section: 'Lease Accounting',
						formType: 'NewCapitalLeaseForm',
					},
					{
						id: 'lease-modification-form',
						label: 'Lease Modification Form',
						route: 'capital-lease/lease-modification-form',
						type: 'form',
						section: 'Lease Accounting',
						formType: 'LeaseModificationForm',
					},
				],
				type: 'form',
				section: 'Lease Accounting',
			},
			{
				id: 'capital-lease-accounting-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'capital-lease-listing',
						label: 'Capital Lease Listing',
						route: 'capital-lease/capital-lease-listing',
						type: 'data-management',
						section: 'Lease Accounting',
					},
					{
						id: 'capital-lease-funds-listing',
						label: 'Fund Listing',
						route: 'capital-lease/capital-lease-funds-listing',
						type: 'data-management',
						section: 'Lease Accounting',
					},
					{
						id: 'capital-lease-functions-configuration',
						label: 'Function Configuration',
						route: 'capital-lease/capital-lease-function-configuration',
						type: 'data-management',
						section: 'Lease Accounting',
					},
				],
				type: 'data-management',
				section: 'Lease Accounting',
			},
			{
				id: 'capital-lease-accounting-reports',
				label: 'Reports',
				children: [
					{
						id: 'capital-lease-balances',
						label: 'Capital Lease Balances',
						route: 'capital-lease/capital-lease-balances',
						type: 'report',
						section: 'Lease Accounting',
					},
					{
						id: 'governmental-fund-balances',
						label: 'Governmental Fund Balances',
						route: 'capital-lease/capital-lease-fund-balances',
						type: 'report',
						section: 'Lease Accounting',
					},
					{
						id: 'journal-entry-report',
						label: 'Journal Entry Report',
						route: 'capital-lease/journal-entry-report',
						type: 'report',
						section: 'Lease Accounting',
					},
					{
						id: 'lease-disclosure-report',
						label: 'Lease Disclosure Report',
						route: 'capital-lease/lease-disclosure-report',
						type: 'report',
						section: 'Lease Accounting',
					},
				],
				type: 'report',
				section: 'Lease Accounting',
			},
		],
		section: 'Lease Accounting',
	},
	{
		id: 'permits-licensing',
		label: 'Licensing',
		children: [
			{
				id: 'permits-licensing-forms',
				label: 'Forms',
				children: [
					{
						id: 'business-license',
						label: 'Business License',
						route: 'licenses/license-form',
						type: 'form',
						section: 'Licensing',
						formType: 'License',
					},
				],
				type: 'form',
				section: 'Licensing',
			},
			{
				id: 'permits-licensing-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'license-list',
						label: 'Licenses Listing',
						route: 'licenses/license-list',
						type: 'data-management',
						section: 'Licensing',
					},
					{
						id: 'license-fees-management',
						label: 'License Fees Management',
						route: 'licenses/fee-types',
						type: 'data-management',
						section: 'Licensing',
					},
					{
						id: 'license-fee-schedules',
						label: 'License Fee Schedules',
						route: 'licenses/fee-schedules',
						type: 'data-management',
						section: 'Licensing',
					},
					{
						id: 'license-credit-card-fee-configuration',
						label: 'Credit Card Fee Configuration',
						route: 'licenses/credit-card-fee-configuration',
						type: 'data-management',
						section: 'Licensing',
					},
				],
				type: 'data-management',
				section: 'Licensing',
			},
			{
				id: 'permits-licensing-reports',
				label: 'Reports',
				children: [
					{
						id: 'inspection-report',
						label: 'Business Inspection Report',
						route: 'licenses/inspection-report',
						type: 'report',
						section: 'Licensing',
					},
					{
						id: 'business-payment-report',
						label: 'Business & Payment Report',
						route: 'licenses/business-payment-report',
						type: 'report',
						section: 'Licensing',
					},
					{
						id: 'license-report',
						label: 'Business License Report',
						route: 'licenses/license-report',
						type: 'report',
						section: 'Licensing',
					},
				],
				type: 'report',
				section: 'Licensing',
			},
		],
		section: 'Licensing',
	},
	{
		id: 'payments',
		label: 'Payments',
		children: [
			{
				id: 'payments-forms',
				label: 'Forms',
				children: [
					{
						id: 'check-request',
						label: 'Check Request',
						route: 'forms/check-request/create',
						type: 'form',
						section: 'Payments',
						formType: 'CheckRequest',
					},
					{
						id: 'cc-approval',
						label: 'Credit Card Approval',
						route: 'forms/cc-approval',
						type: 'form',
						section: 'Payments',
						formType: 'CCApproval',
					},
					{
						id: 'ap-invoice',
						label: 'Invoice Approval Form w/PO',
						route: 'forms/ap-invoice/create',
						type: 'form',
						section: 'Payments',
						formType: 'APInvoice',
					},
					{
						id: 'p-card',
						label: 'P-Card',
						route: 'forms/p-card/create',
						type: 'form',
						section: 'Payments',
						formType: 'PCard',
					},
					{
						id: 'quick-pay',
						label: 'Quick Pay',
						route: 'forms/quick-pay/create',
						type: 'form',
						section: 'Payments',
						formType: 'QuickPayForm',
					},
					{
						id: 'void-reissue-form',
						label: 'Void Reissue Form',
						route: 'forms/void-reissue-form',
						type: 'form',
						section: 'Payments',
						formType: 'VoidReissueForm',
					},
					{
						id: 'scan-invoice',
						label: 'Scan Invoice',
						route: 'forms/scan-invoice',
						type: 'form',
						section: 'Payments',
					},
					{
						id: 'individual-payment-form',
						label: 'Individual Payment Form',
						route: 'forms/individual-payment/create',
						type: 'form',
						section: 'Payments',
						formType: 'IndividualPaymentForm',
					},
					{
						id: 'customer-refund-form',
						label: 'Customer Refund Form',
						route: 'forms/customer-refund-form',
						type: 'form',
						section: 'Payments',
						formType: 'CustomerRefundForm',
					},
					{
						id: 'tax-distribution',
						label: 'Tax Distribution',
						route: 'forms/tax-distribution/create',
						type: 'form',
						section: 'Payments',
						formType: 'TaxDistribution',
					},
					{
						id: 'other-reimbursable-expenses',
						label: 'Other Reimbursable Expenses',
						route: 'forms/other-reimbursable-expenses',
						type: 'form',
						section: 'Payments',
						formType: 'OtherReimbursableExpensesForm',
					},
					{
						id: 'local-vicinity',
						label: 'Local Vicinity Travel',
						route: 'forms/local-vicinity',
						type: 'form',
						section: 'Payments',
						formType: 'LocalVicinityTravelForm',
					},
					{
						id: 'out-of-county-travel',
						label: 'Out Of County Travel',
						route: 'forms/out-of-county-travel',
						type: 'form',
						section: 'Payments',
						formType: 'OutOfCountyTravelForm',
					},
					{
						id: 'fiserv-refund-form',
						label: 'Fiserv Refund Form',
						route: 'forms/fiserv-refund-form',
						type: 'form',
						section: 'Payments',
						formType: 'FiservRefundForm',
					},
					{
						id: 'individual-refund-form',
						label: 'Individual Refund Form',
						route: 'forms/individual-refund-form',
						type: 'form',
						section: 'Payments',
						formType: 'IndividualRefundForm',
					},
					{
						id: 'jury-check-registry-form',
						label: 'Jury Check Registry Form',
						route: 'forms/jury-check-registry-form',
						type: 'form',
						section: 'Payments',
						formType: 'JuryCheckRegistryForm',
					},
					{
						id: 'tuition-reimbursement-payment',
						label: 'Tuition Reimbursement Payment',
						route: 'forms/tuition-reimbursement-payment',
						type: 'form',
						section: 'Payments',
						formType: 'TuitionReimbursementPayment',
					},
					{
						id: 'tax-certificate-redemption-check',
						label: 'Tax Certificate Redemption Check Form',
						route: 'forms/tax-certificate-redemption-check',
						type: 'form',
						section: 'Payments',
						formType: 'TaxCertificateRedemptionCheckForm',
					},
					{
						id: 'tax-certificate-redemption-ach-form',
						label: 'Tax Certificate Redemption ACH Form',
						route: 'forms/tax-certificate-redemption-ach-form',
						type: 'form',
						section: 'Payments',
						formType: 'TaxCertificateRedemptionACHForm',
					},
					{
						id: 'cash-bond-payment-form',
						label: 'Cash Bond Payment Form',
						route: 'forms/cash-bond-payment-form',
						type: 'form',
						section: 'Payments',
						formType: 'CashBondPaymentForm',
					},
					{
						id: 'multiple-vendor-payment',
						label: 'Multiple Vendor Payment',
						route: 'forms/multiple-vendor-payment/create',
						type: 'form',
						section: 'Payments',
						formType: 'MultipleVendorPayment',
					},
					{
						id: 'multiple-payment',
						label: 'Multiple Payment',
						route: 'forms/multiple-payment/create',
						type: 'form',
						section: 'Payments',
						formType: 'MultiplePayment',
					},
					{
						id: 'vendor-credit-memos',
						label: 'Vendor Credit Memo',
						route: 'forms/vendor-credit-memos',
						type: 'form',
						section: 'Payments',
						formType: 'VendorCreditMemoForm',
					},
					{
						id: 'other-tuition-reimbursement-payment',
						label: 'Other Tuition Reimbursement Payment',
						route: 'forms/other-tuition-reimbursement-payment',
						type: 'form',
						section: 'Payments',
						formType: 'OtherTuitionReimbursementPayment',
					},
					{
						id: 'restitution-payment-form',
						label: 'Restitution Payment Form',
						route: 'forms/restitution-payment-form',
						type: 'form',
						section: 'Payments',
						formType: 'RestitutionPaymentForm',
					},
					{
						id: 'special-payment',
						label: 'Special Payment',
						route: 'forms/special-payment/create',
						type: 'form',
						section: 'Payments',
						formType: 'SpecialPayment',
					},
					{
						id: 'employee-reimbursable-expenses',
						label: 'Employee Reimbursable Expenses',
						route: 'forms/employee-reimbursable-expenses',
						type: 'form',
						section: 'Payments',
						formType: 'EmployeeReimbursableExpensesForm',
					},
					{
						id: 'out-of-county-travel-adjustment',
						label: 'Out Of County Travel Adjustment',
						route: 'forms/out-of-county-travel-adjustment',
						type: 'form',
						section: 'Payments',
						formType: 'OutOfCountyTravelAdjustmentForm',
					},
					{
						id: 'travel-reimbursement-payment',
						label: 'Travel Reimbursement',
						route: 'forms/travel-reimbursement-payment/create',
						type: 'form',
						section: 'Payments',
						formType: 'TravelReimbursementPaymentForm',
					},
				],
				type: 'form',
				section: 'Payments',
			},
			{
				id: 'payments-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'po-config',
						label: 'Payment w/PO Tolerance Configurations',
						route: 'forms/purchasing/po-config',
						type: 'data-management',
						section: 'Payments',
					},
					{
						id: '1099-nec-processing',
						label: '1099 Processing',
						route: 'forms/1099-processing',
						type: 'data-management',
						section: 'Payments',
					},
					{
						id: 'duplicate-invoice-configuration',
						label: 'Duplicate Invoice Warning Configuration',
						route: 'forms/purchasing/duplicate-invoice-configuration',
						type: 'data-management',
						section: 'Payments',
					},
					{
						id: 'check-batch-processing',
						label: 'Check Batch Processing',
						route: 'forms/check-batch-processing',
						type: 'data-management',
						section: 'Payments',
					},
					{
						id: 'check-batch-sort-config',
						label: 'Check Batch Report Sort Config',
						route: 'forms/check-batch-sort-config',
						type: 'data-management',
						section: 'Payments',
					},
					{
						id: 'budget-tolerance-config',
						label: 'Budget Tolerance Configuration',
						route: 'forms/payments/budget-tolerance-config',
						type: 'data-management',
						section: 'Payments',
					},
					{
						id: 'bank-account-listing',
						label: 'Bank Account Listing',
						route: 'forms/bank-account-listing',
						type: 'data-management',
						section: 'Payments',
					},
					{
						id: 'positive-pay-configuration',
						label: 'Positive Pay Configuration',
						route: 'forms/payments/positive-pay-configuration',
						type: 'data-management',
						section: 'Payments',
					},
					{
						id: 'cash-bond-listing',
						label: 'Cash Bond Listing',
						route: 'forms/cash-bond-listing',
						type: 'data-management',
						section: 'Payments',
					},
					{
						id: 'ach-batch-configuration',
						label: 'ACH Batch Configuration',
						route: 'forms/payments/ach-batch-configuration',
						type: 'data-management',
						section: 'Payments',
					},
					{
						id: 'vendor-credit-memos-list',
						label: 'Vendor Credit Memos',
						route: 'forms/vendor-credit-memos-list',
						type: 'data-management',
						section: 'Payments',
					},
					{
						id: 'invoice-item-price-adjustment-config',
						label: 'Invoice Item Price Adjustment Configuration',
						route: 'forms/payments/invoice-item-price-adjustment-config',
						type: 'data-management',
						section: 'Payments',
					},
					{
						id: 'reimbursement-rate-configurations',
						label: 'Reimbursement Rate Configuration',
						route: 'forms/reimbursement-rate-configurations',
						type: 'data-management',
						section: 'Payments',
					},
					{
						id: 'card-number-mapping-management',
						label: 'Card Number Mapping Management',
						route: 'forms/card-number-mapping-management',
						type: 'data-management',
						section: 'Payments',
					},
				],
				type: 'data-management',
				section: 'Payments',
			},
			{
				id: 'payments-reports',
				label: 'Reports',
				children: [
					{
						id: 'payment-listing-report',
						label: 'Payment Listing Report',
						route: 'forms/payment-listing-report',
						type: 'report',
						section: 'Payments',
					},
					{
						id: 'payment-transaction-detail-report',
						label: 'Payment Transaction Detail Report',
						route: 'forms/payment-transaction-detail-report',
						type: 'report',
						section: 'Payments',
					},
					{
						id: '1099-report',
						label: '1099 Report',
						route: 'forms/1099-report',
						type: 'report',
						section: 'Payments',
					},
					{
						id: 'check-listing-report',
						label: 'Check Listing Report',
						route: 'forms/check-listing-report',
						type: 'report',
						section: 'Payments',
					},
					{
						id: 'p-card-report',
						label: 'P-Card Report',
						route: 'forms/p-card-report',
						type: 'report',
						section: 'Payments',
					},
					{
						id: 'outstandingAP-report',
						label: 'Outstanding A/P Report',
						route: 'forms/outstandingAP-report',
						type: 'report',
						section: 'Payments',
					},
					{
						id: 'void-re-issue-check-report',
						label: 'Void & Re-Issue Checks Report',
						route: 'forms/void-re-issue-check-report',
						type: 'report',
						section: 'Payments',
					},
					{
						id: 'multiple-payment-report',
						label: 'Multiple Payment Report',
						route: 'forms/multiple-payment-report',
						type: 'report',
						section: 'Payments',
					},
				],
				type: 'report',
				section: 'Payments',
			},
		],
		section: 'Payments',
	},
	{
		id: 'payroll',
		label: 'Payroll',
		children: [
			{
				id: 'payroll-forms',
				label: 'Forms',
				children: [
					{
						id: 'timesheet-approval-form',
						label: 'Timesheet Approval Form',
						route: 'forms/hris/timesheet-approval-form',
						type: 'form',
						section: 'Payroll',
						formType: 'TimesheetApprovalForm',
					},
					{
						id: 'special-pay-form',
						label: 'Special Pay Form',
						route: 'forms/hris/special-pay-form',
						type: 'form',
						section: 'Payroll',
						formType: 'SpecialPayForm',
					},
					{
						id: 'payroll-adjustment-form',
						label: 'Payroll Adjustment Form',
						route: 'forms/hris/payroll-adjustment-form',
						type: 'form',
						section: 'Payroll',
						formType: 'PayrollAdjustmentForm',
					},
				],
				type: 'form',
				section: 'Payroll',
			},
			{
				id: 'payroll-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'time-clock',
						label: 'Time Clock',
						route: 'forms/hris/time-clock',
						type: 'data-management',
						section: 'Payroll',
					},
					{
						id: 'weekly-timesheet',
						label: 'Time Sheet',
						route: 'forms/hris/weekly-timesheet',
						type: 'data-management',
						section: 'Payroll',
					},
					{
						id: 'payroll-processing',
						label: 'Payroll Processing',
						route: 'forms/hris/payroll/history',
						type: 'data-management',
						section: 'Payroll',
					},
					{
						id: 'hris-config',
						label: 'Timesheet Configuration',
						route: 'forms/hris/configuration',
						type: 'data-management',
						section: 'Payroll',
					},
					{
						id: 'timesheet-approval-management',
						label: 'Timesheet Approval Management',
						route: 'forms/hris/timesheet-approval-management',
						type: 'data-management',
						section: 'Payroll',
					},
					{
						id: 'employee-check-batch-processing',
						label: 'Employee Check Batch Processing',
						route: 'forms/hris/employee-check-batch-processing',
						type: 'data-management',
						section: 'Payroll',
					},
					{
						id: 'time-entry-listing',
						label: 'Time Entry List',
						route: 'forms/hris/time-entry-listing',
						type: 'data-management',
						section: 'Payroll',
					},
					{
						id: 'time-sheet-categories',
						label: 'Time Sheet Categories',
						route: 'forms/hris/time-sheet-categories',
						type: 'data-management',
						section: 'Payroll',
					},
					{
						id: 'geofencing-configuration',
						label: 'Geofencing Configuration',
						route: 'forms/hris/geofencing-configuration',
						type: 'data-management',
						section: 'Payroll',
					},
					{
						id: 'time-off-categories',
						label: 'Time Off Categories',
						route: 'forms/hris/time-off-categories',
						type: 'data-management',
						section: 'Payroll',
					},
					{
						id: 'pay-period-configurations',
						label: 'Pay Period Configurations',
						route: 'forms/hris/pay-period-configurations',
						type: 'data-management',
						section: 'Payroll',
					},
					{
						id: '941-processing',
						label: '941 Processing',
						route: 'forms/hris/payroll/941-processing',
						type: 'data-management',
						section: 'Payroll',
					},
					{
						id: 'time-clock-configuration',
						label: 'Time Clock Configuration',
						route: 'forms/hris/time-clock-configuration',
						type: 'data-management',
						section: 'Payroll',
					},
				],
				type: 'data-management',
				section: 'Payroll',
			},
			{
				id: 'payroll-reports',
				label: 'Reports',
				children: [
					{
						id: 'employee-check-listing-report',
						label: 'Employee Check Listing Report',
						route: 'forms/hris/employee-check-listing-report',
						type: 'report',
						section: 'Payroll',
					},
					{
						id: 'payroll-report',
						label: 'Payroll Report',
						route: 'forms/hris/payroll-report',
						type: 'report',
						section: 'Payroll',
					},
					{
						id: 'special-pay-report',
						label: 'Special Pay Report',
						route: 'forms/hris/special-pay-report',
						type: 'report',
						section: 'Payroll',
					},
					{
						id: 'employer-payroll-tax-summary-report',
						label: 'Employer Tax Summary Report',
						route: 'forms/hris/employer-payroll-tax-summary-report',
						type: 'report',
						section: 'Payroll',
					},
					{
						id: 'payroll-summary-report',
						label: 'Payroll Summary Report',
						route: 'forms/hris/payroll-summary-report',
						type: 'report',
						section: 'Payroll',
					},
				],
				type: 'report',
				section: 'Payroll',
			},
		],
		section: 'Payroll',
	},
	{
		id: 'policies-procedures',
		label: 'Policies and Procedures',
		children: [
			{
				id: 'policies-procedures-forms',
				label: 'Forms',
				children: [
					{
						id: 'policy-form',
						label: 'Policy Form',
						route: 'policies-procedures/policy-form',
						type: 'form',
						section: 'Policies and Procedures',
						formType: 'PolicyForm',
					},
					{
						id: 'procedure-form',
						label: 'Procedure Form',
						route: 'policies-procedures/procedure-form',
						type: 'form',
						section: 'Policies and Procedures',
						formType: 'ProcedureForm',
					},
				],
				type: 'form',
				section: 'Policies and Procedures',
			},
			{
				id: 'policies-procedures-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'policies-portal-configuration-management',
						label: 'Policies Portal Configuration',
						route: 'policies-procedures/policies-portal-configuration-management',
						type: 'data-management',
						section: 'Policies and Procedures',
					},
					{
						id: 'policy-management',
						label: 'Policies',
						route: 'policies-procedures/policy-management',
						type: 'data-management',
						section: 'Policies and Procedures',
					},
					{
						id: 'procedures-management',
						label: 'Procedures',
						route: 'policies-procedures/procedures-management',
						type: 'data-management',
						section: 'Policies and Procedures',
					},
				],
				type: 'data-management',
				section: 'Policies and Procedures',
			},
		],
		section: 'Policies and Procedures',
	},
	{
		id: 'project-grants',
		label: 'Projects & Grants',
		children: [
			{
				id: 'project-grants-forms',
				label: 'Forms',
				children: [
					{
						id: 'project-mgt-2',
						label: 'New Project Request Form',
						route: 'project-grants/project-mgt',
						type: 'form',
						section: 'Projects & Grants',
						formType: 'ProjectManagementForm',
					},
					{
						id: 'funding-increase-form',
						label: 'Funding Increase',
						route: 'project-grants/funding-increase-form',
						type: 'form',
						section: 'Projects & Grants',
						formType: 'FundingIncreaseForm',
					},
					{
						id: 'payment-approval-form',
						label: 'Payment Approval',
						route: 'project-grants/payment-approval-form',
						type: 'form',
						section: 'Projects & Grants',
						formType: 'PaymentApprovalForm',
					},
					{
						id: 'project-close-form',
						label: 'Project Close',
						route: 'project-grants/project-close-form',
						type: 'form',
						section: 'Projects & Grants',
						formType: 'ProjectCloseForm',
					},
					{
						id: 'project-open-form',
						label: 'Project Reopen Form',
						route: 'project-grants/project-open-form',
						type: 'form',
						section: 'Projects & Grants',
						formType: 'ProjectOpenForm',
					},
					{
						id: 'project-grant-form',
						label: 'New Project & Grant Form',
						route: 'project-grants/project-grant-form',
						type: 'form',
						section: 'Projects & Grants',
						formType: 'ProjectGrantForm',
					},
					{
						id: 'project-grant-task',
						label: 'Project & Grant New Task Form',
						route: 'project-grants/project-grant-task',
						type: 'form',
						section: 'Projects & Grants',
						formType: 'ProjectGrantTask',
					},
					{
						id: 'project-grant-close-form',
						label: 'Project & Grant Close Form',
						route: 'project-grants/project-grant-close-form',
						type: 'form',
						section: 'Projects & Grants',
						formType: 'ProjectGrantCloseForm',
					},
					{
						id: 'project-grant-reopen-form',
						label: 'Project & Grant Reopen Form',
						route: 'project-grants/project-grant-reopen-form',
						type: 'form',
						section: 'Projects & Grants',
						formType: 'ProjectGrantReOpenForm',
					},
					{
						id: 'transaction-assignment-form',
						label: 'Transaction Assignment Form',
						route: 'project-grants/transaction-assignment-form',
						type: 'form',
						section: 'Projects & Grants',
						formType: 'ProjectGrantLinkageForm',
					},
					{
						id: 'project-grant-compliance-form',
						label: 'Project & Grant Compliance Form',
						route: 'project-grants/project-grant-compliance-form',
						type: 'form',
						section: 'Projects & Grants',
						formType: 'ProjectGrantComplianceForm',
					},
					{
						id: 'cost-allocation-form',
						label: 'Cost Allocation Form',
						route: 'project-grants/cost-allocation-form/create',
						type: 'form',
						section: 'Projects & Grants',
						formType: 'CostAllocationForm',
					},
				],
				type: 'form',
				section: 'Projects & Grants',
			},
			{
				id: 'project-grants-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'project-mgt',
						label: 'Project List',
						route: 'project-grants/project-mgt-list',
						type: 'data-management',
						section: 'Projects & Grants',
					},
					{
						id: 'project-grant-management',
						label: 'Project/Grant Management',
						route: 'project-grants/project-grant-management',
						type: 'data-management',
						section: 'Projects & Grants',
					},
					{
						id: 'cost-allocation-configurations',
						label: 'Cost Allocation Configurations',
						route: 'project-grants/cost-allocation-configurations',
						type: 'data-management',
						section: 'Projects & Grants',
					},
					{
						id: 'subrecipient-funding-source-listing',
						label: 'Funding Source and Subrecipient Listing',
						route: 'project-grants/subrecipient-funding-source-listing',
						type: 'data-management',
						section: 'Projects & Grants',
					},
				],
				type: 'data-management',
				section: 'Projects & Grants',
			},
			{
				id: 'project-grants-reports',
				label: 'Reports',
				children: [
					{
						id: 'funding-report',
						label: 'Funding Report',
						route: 'project-grants/funding-report',
						type: 'report',
						section: 'Projects & Grants',
					},
					{
						id: 'payments-report',
						label: 'Payments Report',
						route: 'project-grants/payments-report',
						type: 'report',
						section: 'Projects & Grants',
					},
					{
						id: 'project-grant-rollforward',
						label: 'Project/Grant Rollforward',
						route: 'project-grants/project-grant-rollforward',
						type: 'report',
						section: 'Projects & Grants',
					},
					{
						id: 'project-grant-transaction-report',
						label: 'Project Grant Transaction Report',
						route: 'project-grants/project-grant-transaction-report',
						type: 'report',
						section: 'Projects & Grants',
					},
					{
						id: 'project-grant-budget-report',
						label: 'Project Grant Budget Report',
						route: 'project-grants/project-grant-budget-report',
						type: 'report',
						section: 'Projects & Grants',
					},
					{
						id: 'project-grant-task-budget-report',
						label: 'Project Grant Task Budget Report',
						route: 'project-grants/project-grant-task-budget-report',
						type: 'report',
						section: 'Projects & Grants',
					},
				],
				type: 'report',
				section: 'Projects & Grants',
			},
		],
		section: 'Projects & Grants',
	},
	{
		id: 'purchasing',
		label: 'Purchasing',
		children: [
			{
				id: 'purchasing-forms',
				label: 'Forms',
				children: [
					{
						id: 'vendor-form',
						label: 'Vendor Form',
						route: 'forms/vendor-form',
						type: 'form',
						section: 'Purchasing',
						formType: 'Vendor',
					},
					{
						id: 'change-order',
						label: 'Change Order',
						route: 'forms/change-order/create',
						type: 'form',
						section: 'Purchasing',
						formType: 'ChangeOrder',
					},
					{
						id: 'purchasing',
						label: 'Purchasing Requisition',
						route: 'forms/purchasing/create',
						type: 'form',
						section: 'Purchasing',
						formType: 'Purchasing',
					},
					{
						id: 'bid-form',
						label: 'Bid Form',
						route: 'forms/bid-form',
						type: 'form',
						section: 'Purchasing',
						formType: 'Bid',
					},
					{
						id: 'initial-purchase-request-form',
						label: 'Initial Purchase Request Form',
						route: 'forms/initial-purchase-request-form',
						type: 'form',
						section: 'Purchasing',
						formType: 'InitialPurchaseRequestForm',
					},
					{
						id: 'field-purchase-order-request-form',
						label: 'Field Purchase Order Request Form',
						route: 'forms/field-purchase-order-request-form',
						type: 'form',
						section: 'Purchasing',
						formType: 'FieldPaymentRequestForm',
					},
					{
						id: 'invoice-approval',
						label: 'Invoice Approval',
						route: 'forms/invoice-approval',
						type: 'form',
						section: 'Purchasing',
						formType: 'InvoiceApproval',
					},
					{
						id: 'po-rollover-form',
						label: 'PO Rollover',
						route: 'forms/po-rollover-form',
						type: 'form',
						section: 'Purchasing',
						formType: 'PoRolloverForm',
					},
					{
						id: 'contract-approval',
						label: 'Contract Approval',
						route: 'forms/contract-approval',
						type: 'form',
						section: 'Purchasing',
						formType: 'ContractApproval',
					},
					{
						id: 'individual-payee-form',
						label: 'Individual Payee Form',
						route: 'forms/individual-payee-form',
						type: 'form',
						section: 'Purchasing',
						formType: 'IndividualPayeeForm',
					},
					{
						id: 'purchasing-employee-form',
						label: 'Employee Form',
						route: 'forms/purchasing-employee-form',
						type: 'form',
						section: 'Purchasing',
						formType: 'PurchasingEmployee',
					},
					{
						id: 'taxing-jurisdiction-form',
						label: 'Taxing Jurisdiction Form',
						route: 'forms/taxing-jurisdiction-form',
						type: 'form',
						section: 'Purchasing',
						formType: 'TaxingJurisdiction',
					},
					{
						id: 'contract-amendment',
						label: 'Contract Amendment',
						route: 'forms/contract-amendment',
						type: 'form',
						section: 'Purchasing',
						formType: 'ContractAmendment',
					},
					{
						id: 'parent-vendor-form',
						label: 'Parent Vendor Form',
						route: 'forms/parent-vendor-form',
						type: 'form',
						section: 'Purchasing',
						formType: 'ParentVendor',
					},
				],
				type: 'form',
				section: 'Purchasing',
			},
			{
				id: 'purchasing-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'field-purchase-order-request-list',
						label: 'Field Purchase Order Requests',
						route: 'forms/field-purchase-order-request-list',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'vendor-management',
						label: 'Vendor Management',
						route: 'forms/vendor-form-list',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'contract-management',
						label: 'Contract Management',
						route: 'forms/contract-management',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'individual-payee-management',
						label: 'Individual Payee Management',
						route: 'forms/individual-payee-management',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'purchase-order-management',
						label: 'Purchase Order Management',
						route: 'forms/purchase-order-management',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'procurement-method-configuration-list',
						label: 'Procurement Method Configuration',
						route: 'forms/procurement-method-configuration-list',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'purchasing-employee-management',
						label: 'Employee Management',
						route: 'forms/purchasing-employee-management',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'taxing-jurisdiction-management',
						label: 'Taxing Jurisdiction Management',
						route: 'forms/taxing-jurisdiction-management',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'payee-configuration',
						label: 'Payee Configuration',
						route: 'forms/payee-configuration',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'po-fiscal-year-configuration',
						label: 'PO Fiscal Year Configuration',
						route: 'forms/po-fiscal-year-configuration',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'initial-purchase-request-list',
						label: 'Initial Purchase Requests',
						route: 'forms/initial-purchase-request-list',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'duplicate-vendor-configuration',
						label: 'Duplicate Vendor Warning Configuration',
						route: 'forms/duplicate-vendor-configuration',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'parent-vendor-management',
						label: 'Parent Vendor Management',
						route: 'forms/parent-vendor-management',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'purchasing-locations',
						label: 'Purchasing Locations',
						route: 'forms/purchasing-locations',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'po-remark-code-management',
						label: 'PO Remark Code Management',
						route: 'forms/po-remark-code-management',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'retention-type-configuration',
						label: 'Retention Type Configuration',
						route: 'forms/retention-type-configuration',
						type: 'data-management',
						section: 'Purchasing',
					},
					{
						id: 'contract-type-configuration',
						label: 'Contract Type Configuration',
						route: 'forms/contract-type-configuration',
						type: 'data-management',
						section: 'Purchasing',
					},
				],
				type: 'data-management',
				section: 'Purchasing',
			},
			{
				id: 'purchasing-reports',
				label: 'Reports',
				children: [
					{
						id: 'po-report',
						label: 'PO Report',
						route: 'forms/po-report',
						type: 'report',
						section: 'Purchasing',
					},
				],
				type: 'report',
				section: 'Purchasing',
			},
		],
		section: 'Purchasing',
	},
	{
		id: 'custom-reporting',
		label: 'Reporting',
		children: [
			{
				id: 'custom-reporting-reports',
				label: 'Reports',
				children: [
					{
						id: 'financial-reporting',
						label: 'Financial Reports',
						route: 'generalledger/financial-reporting',
						type: 'report',
						section: 'Reporting',
					},
					{
						id: 'tax-returns',
						label: 'Tax Returns',
						route: 'generalledger/tax-returns',
						type: 'report',
						section: 'Reporting',
					},
					{
						id: 'balance-sheet-govt-funds',
						label: 'Balance Sheet Governmental Funds',
						route: 'generalledger/balance-sheet-govt-funds',
						type: 'report',
						section: 'Reporting',
					},
					{
						id: 'sonp-proprietary-funds',
						label: 'SONP - Proprietary Fund',
						route: 'generalledger/sonp-proprietary-funds',
						type: 'report',
						section: 'Reporting',
					},
					{
						id: 'standard-report',
						label: 'Standard Reports',
						route: 'generalledger/standard-report',
						type: 'report',
						section: 'Reporting',
					},
					{
						id: 'report-writer',
						label: 'Report Writer',
						route: 'generalledger/report-writer',
						type: 'report',
						section: 'Reporting',
					},
					{
						id: 'report-viewer',
						label: 'Report Viewer',
						route: 'generalledger/report-viewer',
						type: 'report',
						section: 'Reporting',
					},
				],
				type: 'report',
				section: 'Reporting',
			},
		],
		section: 'Reporting',
	},
	{
		id: 'segmentation',
		label: 'Segmentation',
		children: [
			{
				id: 'segmentation-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'custom-segmentation',
						label: 'Custom Segmentation Configuration',
						route: 'segmentation/custom-segmentation',
						type: 'data-management',
						section: 'Segmentation',
					},
				],
				type: 'data-management',
				section: 'Segmentation',
			},
			{
				id: 'segmentation-reports',
				label: 'Reports',
				children: [
					{
						id: 'segment-transaction-detail-report',
						label: 'Segment Transaction Detail Report',
						route: 'segmentation/segment-transaction-detail-report',
						type: 'report',
						section: 'Segmentation',
					},
					{
						id: 'segment-budget-report',
						label: 'Segment Budget Report',
						route: 'segmentation/segment-budget-report',
						type: 'report',
						section: 'Segmentation',
					},
				],
				type: 'report',
				section: 'Segmentation',
			},
		],
		section: 'Segmentation',
	},
	{
		id: 'task-mng',
		label: 'Task Management',
		children: [
			{
				id: 'task-mng-forms',
				label: 'Forms',
				children: [
					{
						id: 'request-form',
						label: 'Generic Tasks',
						route: 'forms/request-form/create',
						type: 'form',
						section: 'Task Management',
						formType: 'RequestForm',
					},
					{
						id: 'vendor-information-change-request',
						label: 'Vendor Information Change Request Form',
						route: 'forms/vendor-information-change-request/create',
						type: 'form',
						section: 'Task Management',
						formType: 'VendorInformationChangeRequest',
					},
					{
						id: 'ye-request',
						label: 'Year End Request Item',
						route: 'forms/ye-request/create',
						type: 'form',
						section: 'Task Management',
						formType: 'YeRequestForm',
					},
					{
						id: 'fieldwork-request',
						label: 'Audit Fieldwork Request',
						route: 'forms/fieldwork-request/create',
						type: 'form',
						section: 'Task Management',
						formType: 'FieldWorkRequestForm',
					},
					{
						id: 'receipt-verification',
						label: 'Receipt Verification Form',
						route: 'forms/receipt-verification/create',
						type: 'form',
						section: 'Task Management',
						formType: 'ReceiptVerification',
					},
					{
						id: 'work-order-request',
						label: 'Work Order Request Form',
						route: 'forms/work-order-request',
						type: 'form',
						section: 'Task Management',
						formType: 'WorkOrderRequestForm',
					},
					{
						id: 'travel-pre-approval',
						label: 'Travel Pre Approval',
						route: 'forms/travel-pre-approval',
						type: 'form',
						section: 'Task Management',
						formType: 'TravelPreApprovalForm',
					},
					{
						id: 'travel-reimbursement',
						label: 'Travel Reimbursement',
						route: 'forms/travel-reimbursement',
						type: 'form',
						section: 'Task Management',
						formType: 'TravelReimbursementForm',
					},
					{
						id: 'tuition-reimbursement-pre-approval',
						label: 'Tuition Reimbursement Pre-Approval',
						route: 'forms/tuition-reimbursement-pre-approval',
						type: 'form',
						section: 'Task Management',
						formType: 'TuitionReimbPreApprovalForm',
					},
					{
						id: 'tuition-reimbursement',
						label: 'Tuition Reimbursement Request Form',
						route: 'forms/tuition-reimbursement',
						type: 'form',
						section: 'Task Management',
						formType: 'TuitionReimbursementForm',
					},
					{
						id: 'other-tuition-reimbursement',
						label: 'Other Tuition Reimbursement Request Form',
						route: 'forms/other-tuition-reimbursement',
						type: 'form',
						section: 'Task Management',
						formType: 'OtherTuitionReimbursementForm',
					},
					{
						id: 'customized-task-form',
						label: 'Customized Task Form',
						route: 'forms/customized-task-form',
						type: 'form',
						section: 'Task Management',
						formType: 'CustomizedTaskForm',
					},
				],
				type: 'form',
				section: 'Task Management',
			},
			{
				id: 'task-mng-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'portal-configurations-management',
						label: 'Portal Configurations Management',
						route: 'forms/portal-configurations-management',
						type: 'data-management',
						section: 'Task Management',
					},
					{
						id: 'forms-scheduling-management',
						label: 'Forms Scheduling Management',
						route: 'forms/forms-scheduling-management',
						type: 'data-management',
						section: 'Task Management',
					},
					{
						id: 'tdt-audit-submissions',
						label: 'TDT Audit Submissions',
						route: 'forms/tdt-audit-submissions',
						type: 'data-management',
						section: 'Task Management',
					},
					{
						id: 'tuition-reimbursement-management',
						label: 'Tuition Reimbursement Management',
						route: 'forms/tuition-reimbursement-management',
						type: 'data-management',
						section: 'Task Management',
					},
				],
				type: 'data-management',
				section: 'Task Management',
			},
		],
		section: 'Task Management',
	},
	{
		id: 'templates',
		label: 'Templates',
		children: [
			{
				id: 'templates-forms',
				label: 'Forms',
				children: [
					{
						id: 'new-template',
						label: 'New Templates',
						route: 'templates/new-template',
						type: 'form',
						section: 'Templates',
					},
				],
				type: 'form',
				section: 'Templates',
			},
			{
				id: 'templates-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'template-list',
						label: 'Template List',
						route: 'templates/template-list',
						type: 'data-management',
						section: 'Templates',
					},
				],
				type: 'data-management',
				section: 'Templates',
			},
		],
		section: 'Templates',
	},
	{
		id: 'training',
		label: 'Training',
		children: [
			{
				id: 'general-ledger-training',
				label: 'General Ledger',
				route: 'training/general-ledger',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'billing-ar-training',
				label: 'Billing & AR',
				route: 'training/billingar',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'sftp-training',
				label: 'SFTP',
				route: 'training/sftp',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'purchasing-training',
				label: 'Purchasing',
				route: 'training/purchasing',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'cashiering-training',
				label: 'Cashiering',
				route: 'training/cashiering',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'general-navigation-training',
				label: 'General Navigation',
				route: 'training/generalnavigation',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'workflow-management-training',
				label: 'Workflow Management',
				route: 'training/workflowmanagement',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'user-management-training',
				label: 'User Management',
				route: 'training/usermanagement',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'payment-training',
				label: 'Payments',
				route: 'training/payments',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'template-training',
				label: 'Templates',
				route: 'training/templates',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'lease-accounting-training',
				label: 'Lease Accounting',
				route: 'training/leaseaccounting',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'permitting-training',
				label: 'Permitting',
				route: 'training/permitting',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'hr-payroll',
				label: 'HR and Payroll',
				route: 'training/hrpayroll',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'capital-assets-training',
				label: 'Capital Assets',
				route: 'training/capital-assets',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'task-management-training',
				label: 'Task Management',
				route: 'training/task-management',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'projects-and-grants-training',
				label: 'Projects And Grants',
				route: 'training/projects-and-grants',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'telerik-reporting-training',
				label: 'Telerik Reporting',
				route: 'training/telerik-reporting',
				type: 'link',
				section: 'Training',
			},
			{
				id: 'budget-training',
				label: 'Budget',
				route: 'training/budget',
				type: 'link',
				section: 'Training',
			},
		],
		section: 'Training',
	},
	{
		id: 'treasury-management',
		label: 'Treasury Management',
		children: [
			{
				id: 'treasury-management-forms',
				label: 'Forms',
				children: [
					{
						id: 'bank-reconciliation',
						label: 'Pooled Cash Bank Reconciliation Form',
						route: 'generalledger/bank-reconciliation',
						type: 'form',
						section: 'Treasury Management',
						formType: 'BankReconciliationForm',
					},
					{
						id: 'investment-income-allocation-form',
						label: 'Investment Income Allocation Form',
						route: 'generalledger/investment-income-allocation-form',
						type: 'form',
						section: 'Treasury Management',
						formType: 'InvestmentIncomeAllocationForm',
					},
					{
						id: 'other-bank-reconciliation',
						label: 'Other Bank Reconciliation Form',
						route: 'generalledger/other-bank-reconciliation',
						type: 'form',
						section: 'Treasury Management',
						formType: 'OtherBankReconciliationForm',
					},
				],
				type: 'form',
				section: 'Treasury Management',
			},
			{
				id: 'treasury-management-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'bank-rec-transactions',
						label: 'Pooled Cash Bank Rec Transactions',
						route: 'generalledger/bank-rec-transactions',
						type: 'data-management',
						section: 'Treasury Management',
					},
					{
						id: 'bank-rec-match-config',
						label: 'Auto-Matching Configuration',
						route: 'generalledger/bank-rec-match-config',
						type: 'data-management',
						section: 'Treasury Management',
					},
					{
						id: 'bank-matching-configuration',
						label: 'Bank Matching Configuration',
						route: 'generalledger/bank-matching-configuration',
						type: 'data-management',
						section: 'Treasury Management',
					},
					{
						id: 'other-bank-rec-transactions',
						label: 'Other Bank Rec Transactions',
						route: 'generalledger/other-bank-rec-transactions',
						type: 'data-management',
						section: 'Treasury Management',
					},
					{
						id: 'outstanding-check-listing',
						label: 'Outstanding Check Listing',
						route: 'generalledger/outstanding-check-listing',
						type: 'data-management',
						section: 'Treasury Management',
					},
				],
				type: 'data-management',
				section: 'Treasury Management',
			},
		],
		section: 'Treasury Management',
	},
	{
		id: 'user-management',
		label: 'User Management',
		children: [
			{
				id: 'user-management-forms',
				label: 'Forms',
				children: [
					{
						id: 'user-form',
						label: 'User Form',
						route: 'user-management/user-form',
						type: 'form',
						section: 'User Management',
						formType: 'UserWorkflowForm',
					},
				],
				type: 'form',
				section: 'User Management',
			},
			{
				id: 'user-management-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'user-list',
						label: 'User List',
						route: 'user-management/user-list',
						type: 'data-management',
						section: 'User Management',
					},
					{
						id: 'custom-roles-list',
						label: 'Custom Roles',
						route: 'user-management/custom-roles-list',
						type: 'data-management',
						section: 'User Management',
					},
					{
						id: 'entity-department-assignments',
						label: 'Entity/Department Assignments',
						route: 'user-management/entity-department-assignments',
						type: 'data-management',
						section: 'User Management',
					},
				],
				type: 'data-management',
				section: 'User Management',
			},
			{
				id: 'user-management-reports',
				label: 'Reports',
				children: [
					{
						id: 'user-report',
						label: 'User Report',
						route: 'user-management/user-report',
						type: 'report',
						section: 'User Management',
					},
					{
						id: 'audit-log-report',
						label: 'Audit Log Report',
						route: 'user-management/audit-log-report',
						type: 'report',
						section: 'User Management',
					},
					{
						id: 'user-access-report',
						label: 'User Access Report',
						route: 'user-management/user-access-report',
						type: 'report',
						section: 'User Management',
					},
				],
				type: 'report',
				section: 'User Management',
			},
		],
		section: 'User Management',
	},
	{
		id: 'workflow-management',
		label: 'Workflow Management',
		children: [
			{
				id: 'workflow-management-forms',
				label: 'Forms',
				children: [
					{
						id: 'workflow-group-form',
						label: 'Workflow Group Form',
						route: 'workflow-management/workflow-group-form',
						type: 'form',
						section: 'Workflow Management',
						formType: 'WorkflowGroup',
					},
					{
						id: '',
						label: 'Workflow User Designation',
						route: 'workflow-management/workflow-user-designation',
						type: 'form',
						section: 'Workflow Management',
						formType: 'WorkflowUserDesignation',
					},
				],
				type: 'form',
				section: 'Workflow Management',
			},
			{
				id: 'workflow-management-data-management',
				label: 'Data Management',
				children: [
					{
						id: 'workflow-group-list',
						label: 'Workflow Group List',
						route: 'workflow-management/workflow-group-list',
						type: 'data-management',
						section: 'Workflow Management',
					},
					{
						id: 'workflow-forms-setting',
						label: 'Forms Workflow',
						route: 'workflow-management/workflow-forms-setting',
						type: 'data-management',
						section: 'Workflow Management',
					},
					{
						id: 'workflow-email-settings',
						label: 'Email Settings',
						route: 'workflow-management/workflow-email-settings',
						type: 'data-management',
						section: 'Workflow Management',
					},
				],
				type: 'data-management',
				section: 'Workflow Management',
			},
			{
				id: 'workflow-management-reports',
				label: 'Reports',
				children: [
					{
						id: 'workflow-group-report',
						label: 'Workflow Report',
						route: 'workflow-management/workflow-group-report',
						type: 'report',
						section: 'Workflow Management',
					},
				],
				type: 'report',
				section: 'Workflow Management',
			},
		],
		section: 'Workflow Management',
	},
];
